<template>
  <div id="project-deputy" class="deputy-project" data-aos="zoom-out" data-aos-duration="1500">
    <div class="deputy-project-row container">
      <MyTitle>
        <template v-slot:title><b style="color: #1E55AE">代表</b>工程</template>
      </MyTitle>
      <ul class="deputy-project-list" v-loading="loading" element-loading-text="拼命加载中...">
        <li v-for="item in deputyProject" :key="item.id" data-aos="zoom-in" data-aos-duration="1500">
          <div class="seat-box">
            <a @click="$bus.$emit('showContent',item.content)">
              <el-image :src="item.image_url" lazy>
                <div slot="placeholder" class="image-slot">
                  <img src="@/assets/images/loading.gif" alt="loading" style="width: 100px;">
                </div>
              </el-image>
              <p>{{ item.title }}</p>
            </a>
          </div>
        </li>
        <el-empty :image-size="200" v-if="deputyProject.length === 0"></el-empty>
      </ul>
    </div>

  </div>
</template>

<script>

export default {
  name: "DeputyProject",
  data() {
    return {
      deputyProject: [],
      activeItem: -1,
      loading: false,
    }
  },
  methods: {
    // 获取代表工程数据
    getDeputyProject() {
      this.loading = true
      this.$api.reqDeputyProject().then(results => {
        if (results.status === 200) {
          this.deputyProject = results.results
        } else {
          Promise.reject('error')
        }
      }).catch(() => {
        this.$message({showClose: true, message: "代表工程数据请求失败！", type: "error"})
      }).finally(() => {
        this.loading = false
      })
    },
  },
  mounted() {
    this.getDeputyProject()
  }
}
</script>

<style scoped lang="less">
.deputy-project {
  padding: 80px 0;

  .deputy-project-row {

    .deputy-project-list {
      display: flex;
      justify-content: center;
      flex-direction: row;
      flex-wrap: wrap;
      margin-top: 60px;
      min-height: 320px;

      li {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 10px;
        width: 375px;
        height: 310px;
        text-align: center;
        background-color: #fffffd;


        .seat-box {
          width: 350px;
          height: 290px;
          overflow: hidden;
          border: 1px solid #ebeef5;
          border-radius: 8px;
          box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
          font-size: 16px;
          line-height: 30px;

          -webkit-transition: all 0.4s;
          transition: all 0.4s;

          &:hover {
            width: 375px;
            height: 310px;
            line-height: 32px;
          }

          a {
            color: #303133;
            cursor: pointer;

            .el-image {
              line-height: 260px;

              .image-slot {
                width: 350px;
                height: 290px;
              }
            }

            div {
              height: 83%;
            }
          }
        }
      }


    }
  }
}
</style>